import { configureStore } from "@reduxjs/toolkit";
import pencil from "./modules/pencil";
import eraser from "./modules/eraser";
import btnsel from "./modules/btnsel";
import palette from "./modules/palette";
import btnrec from "./modules/btnrec";
import tabplate from "./modules/tabplate";
import timerslice from "./modules/timerslice";
import logininfo from "./modules/logininfo";
import colorplate from "./modules/colorplate";
import crsytal from "./modules/crsytal";
import language from "./modules/language";
import helpinfo from "./modules/helpinfo";
import timerId from "./modules/timerId";
import helpdialog from "./modules/helpdialogshow";

export default configureStore({
  reducer:{
    pencil,
    eraser,
    btnsel,
    palette,
    btnrec,
    tabplate,
    timerslice,
    timerId,
    logininfo,
    colorplate,
    crsytal,
    language,
    helpinfo,
    helpdialog
  }
});